import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';

import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockReplenishmentRunFilterItemModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-run-filter-item.model';


@Injectable({ providedIn: 'root' })
export class StockReplenishmentRunFilterItemService extends BaseApiTemplateService<StockReplenishmentRunFilterItemModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-run-items/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-run-items/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-run-items/backoffice-ep';
    this.httpClient = theHttp;
  }

  public getStockReplenishmentRunFilterItem(apiVisa: ApiVisa): Observable<StockReplenishmentRunFilterItemModel> {
    const headers = new HttpHeaders({
      "Authorization": localStorage.getItem('authToken'),
      "tenantCode": localStorage.getItem('tenantCode'),
    });

    const options = {
      headers: headers
    }

    return this.httpClient.get<StockReplenishmentRunFilterItemModel>(
      this.url, options
    );
  }



}
